module.exports = __webpack_public_path__ + "img/neighbor-6-supp.d67c4cf3.png";